var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.6666 20.8266V37.0666L54.3199 33.3333C52.2399 31.5466 48.8799 31.5466 46.7999 33.3333L35.7066 42.8533C33.6266 44.64 30.2666 44.64 28.1866 42.8533L27.2799 42.1066C25.3866 40.4533 22.3733 40.2933 20.2399 41.7333L7.11992 50.5333L6.82659 50.7467C5.83992 48.6133 5.33325 46.08 5.33325 43.1733V20.8266C5.33325 11.12 11.1199 5.33331 20.8266 5.33331H43.1733C52.8799 5.33331 58.6666 11.12 58.6666 20.8266Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.68C27.5052 27.68 30.3467 24.8385 30.3467 21.3334C30.3467 17.8282 27.5052 14.9867 24 14.9867C20.4948 14.9867 17.6533 17.8282 17.6533 21.3334C17.6533 24.8385 20.4948 27.68 24 27.68Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 37.0667V43.1733C58.6667 52.88 52.88 58.6667 43.1733 58.6667H20.8267C14.0267 58.6667 9.11999 55.8134 6.82666 50.7467L7.11999 50.5333L20.24 41.7333C22.3733 40.2933 25.3867 40.4533 27.28 42.1067L28.1867 42.8533C30.2667 44.64 33.6267 44.64 35.7067 42.8533L46.8 33.3333C48.88 31.5467 52.24 31.5467 54.32 33.3333L58.6667 37.0667Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryProfile);
export default __webpack_public_path__ + "static/media/galleryProfile.c43328bcb7ae9adaa77b5d7f92cc7ace.svg";
export { ForwardRef as ReactComponent };